import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "error", "checked", "onBlur", "onChange", "helperText", "FormControlProps", "FormControlLabelProps"];
import { Checkbox, FormControl as FormControlMui, FormControlLabel, FormHelperText as FormHelperTextMui } from '@material-ui/core';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FormControl = /*#__PURE__*/styled(FormControlMui).withConfig({
  displayName: "CheckboxField__FormControl",
  componentId: "SD__sc-1wxu0g6-0"
})(["justify-content:center;"]);
var FormHelperText = /*#__PURE__*/styled(FormHelperTextMui).withConfig({
  displayName: "CheckboxField__FormHelperText",
  componentId: "SD__sc-1wxu0g6-1"
})(["color:", ";margin-left:30px;margin-top:0;margin-bottom:4px;&.Mui-error{color:", ";}"], ColorDynamic.Dark300, ColorDynamic.Red500);
export var CheckboxField = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      label,
      error,
      checked,
      onBlur,
      onChange,
      helperText,
      FormControlProps: formControlProps,
      FormControlLabelProps: formControlLabelProps
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(FormControl, _objectSpread(_objectSpread({
    error: error
  }, formControlProps), {}, {
    children: [/*#__PURE__*/_jsx(FormControlLabel, _objectSpread(_objectSpread({}, formControlLabelProps), {}, {
      label: label,
      checked: checked,
      onBlur: onBlur,
      onChange: onChange,
      control: /*#__PURE__*/_jsx(Checkbox, _objectSpread({
        ref: ref,
        color: "primary"
      }, props))
    })), helperText && /*#__PURE__*/_jsx(FormHelperText, {
      children: helperText
    })]
  }));
});
if (process.env.NODE_ENV !== "production") CheckboxField.displayName = "CheckboxField";